import { createSlice } from "@reduxjs/toolkit";
import { current } from "@reduxjs/toolkit";
const initialState = {
	languages: {
		lang: "",
		langLabel: "",
	},
};

export const languagesSlice = createSlice({
	name: "languages",
	initialState,
	reducers: {
		addLang: (state, { payload }) => {
			state.languages.lang = payload;
		},
		addLangLabel: (state, { payload }) => {
			state.languages.langLabel = payload;
		},
	},
},
);

export const {
	addLang,
	addLangLabel
} = languagesSlice.actions;
export default languagesSlice.reducer;
